import React, { useState, useEffect } from "react";

export const NotificationModel = ({ open, setOpen, message }) => {
  return (
    <div className={`modal ${open ? "modal--show" : ""}`}>
      <div
        className="modal__dialog"
        style={{ width: "100%", maxWidth: "calc(582px + 40px)" }}
      >
        <div className="modal__content">
          <div className="modal__body py-40 px-60">
            <div className="d-flex flex-column text-center">
              <h3 className="heading-3 mb-10" style={{ lineHeight: "30px" }}>
                {message}
              </h3>
            </div>

            <button className="btn btn-success btn--md radius-5 ttu"
              onClick={() => {
                setOpen(false);
              }}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
